import { Component } from 'react';
import {Link} from 'react-router-dom';
import {Col, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {delinkUserOutlet, getOutlet} from '../../actions/outlet';


import Title from '../common/title';
import ConfirmPopup from '../common/confirm-popup';
import ArrowButton from '../common/button-arrow';
import noPhoto from '../../assets/img/no_photo.png';

import './store-details.css';

class MyStoreDetails extends Component {
  smClose = (result) => {
    if (result) {
      this
        .props
        .dispatch(delinkUserOutlet(this.props.storeId));
    }
    this.setState({smShow: false});
  };

  constructor(props) {
    super(props);
    this.state = {
      smShow: false,
    };
  }

  onDelinkClicked() {
    this.setState({smShow: true});
  }

  onOrderNowClicked() {
    this.setState({orderShow: true});
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getOutlet(this.props.storeId));
  }

  render() {
    const {store} = this.props;
    const {representative} = store;

    let repImage = noPhoto;

    try {
      if (representative.image) {
        repImage = representative.image;
      }
    } catch (e) {
      repImage = noPhoto;
    }

    return (
      <div className="store-details">
        <Row className="store-details-info">
          <Col className="rep-details" md={3}>
            <div className="store-details-info-rep">
              <h3 className="rep-title center-text store-details-info-rep-title">
                Your rep
              </h3>
              <img alt="Your rep" className="rep-image" src={repImage}/>
              {representative && (
                <div className="rep-name">
                  {`${representative['first-name'] || ''} ${representative['last-name'] || ''}`}
                </div>
              )}
            </div>
          </Col>
          <Col md={6} className="store-details-info-address">
            <div>
              <h3>
                <div>
                  <Title>
                    {store.name || ''}
                  </Title>
                </div>
              </h3>
              <h4>
                <div>
                  {'CUSTOMER NUMBER: '}
                  {store['customer-number'] || ''}
                </div>
                <div>
                  {store['address-2'] || ''}
                </div>
                <div>
                  {store['address-3'] || ''}
                </div>
                <div>
                  {store['address-1'] || ''}
                </div>
                <div>
                  {store.town || ''}
                </div>
                <div>
                  {store.county || ''}
                </div>
                <div>
                  {store.eircode || ''}
                </div>
              </h4>
            </div>
          </Col>
          <Col md={3} className="store-details-info-nav">
            <h4 className="store-details-info-nav-title">QUICK LINKS</h4>
            <div className="store-details-info-nav-seperator" />
            <Link to="/" className="store-details-info-nav-link">Home</Link>
            <Link to="/products" className="store-details-info-nav-link">Products/Brands</Link>
            <Link to="/tbc" className="store-details-info-nav-link">POR Deals</Link>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3} className="store-details-button-container">
            <ArrowButton
              arrow={false}
              className="float-start"
              onClick={() => this.onDelinkClicked()}
              submit={false}
            >
              Remove store
            </ArrowButton>

            {this.state.smShow && (
              <ConfirmPopup onClose={this.smClose}>
                <p>
                  Are you sure you want to remove this store from your
                  <strong>
                    {' '}
                    ignite
                    {' '}
                  </strong>
                  account? If you select confirm, your request will be sent to the
                  <strong>
                    {' '}
                    ignite
                    {' '}
                  </strong>
                  administration team.
                </p>
              </ConfirmPopup>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store.store,
});

export default connect(mapStateToProps)(MyStoreDetails);
